// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../../../utils/Utils.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var TailwindMerge = require("tailwind-merge");
var AgentProfilePhoto = require("../../common/Agent/AgentProfilePhoto.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ConversationParticipantsDisplay_participantsConnection_graphql = require("../../../__generated__/ConversationParticipantsDisplay_participantsConnection_graphql.bs.js");

var avatarStyles = "border-[3px] border-white";

var avatarClasses = "w-14 h-14 " + avatarStyles;

function ConversationParticipantsDisplay$ByParticipants(props) {
  var __showNames = props.showNames;
  var participants = props.participants;
  var showNames = __showNames !== undefined ? __showNames : true;
  var printAvatar = function (p, classNameOpt, param) {
    var className = classNameOpt !== undefined ? classNameOpt : avatarClasses;
    if (typeof p === "object" && p.TAG === "Agent") {
      return JsxRuntime.jsx(AgentProfilePhoto.make, {
                  profilePhoto: p.fragmentRefs,
                  className: className
                });
    }
    return JsxRuntime.jsx(AgentProfilePhoto.Avatar.make, {
                alt: "Anonymous participant",
                className: className
              });
  };
  var match = participants[0];
  var match$1 = participants[1];
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: match !== undefined ? (
                          match$1 !== undefined ? JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          children: printAvatar(match, TailwindMerge.twMerge([
                                                    avatarStyles,
                                                    "w-11 h-11"
                                                  ]), undefined),
                                          className: "absolute bottom-0 right-0"
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: printAvatar(match$1, TailwindMerge.twMerge([
                                                    avatarStyles,
                                                    "w-11 h-11"
                                                  ]), undefined),
                                          className: "absolute top-0 left-0"
                                        })
                                  ],
                                  className: "flex flex-row relative h-14 w-14"
                                }) : JsxRuntime.jsx("div", {
                                  children: printAvatar(match, undefined, undefined)
                                })
                        ) : null
                    }),
                showNames ? JsxRuntime.jsx("div", {
                        children: (function (__x) {
                              return Utils.$$Array.pseudoJoin(", ", undefined, __x);
                            })(participants.map(function (n) {
                                  var displayName;
                                  var id;
                                  if (typeof n !== "object") {
                                    return "Agent chose to hide their name";
                                  }
                                  if (n.TAG === "Agent") {
                                    displayName = n.displayName;
                                    id = n.id;
                                  } else {
                                    displayName = n.displayName;
                                    id = n.id;
                                  }
                                  return JsxRuntime.jsx(ButtonsV5.Link.make, {
                                              href: "/agents/" + id,
                                              className: "hover:underline",
                                              children: Caml_option.some(displayName)
                                            });
                                })),
                        className: "font-semibold line-clamp-1"
                      }) : null
              ],
              className: "flex flex-row space-x-2 items-center"
            });
}

var ByParticipants = {
  make: ConversationParticipantsDisplay$ByParticipants
};

var convertFragment = ConversationParticipantsDisplay_participantsConnection_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationParticipantsDisplay_participantsConnection_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationParticipantsDisplay_participantsConnection_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationParticipantsDisplay_participantsConnection_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationParticipantsDisplay_participantsConnection_graphql.node, convertFragment, fRef);
}

var ParticipantsConnectionFragment_membershipStatusV5_decode = ConversationParticipantsDisplay_participantsConnection_graphql.Utils.membershipStatusV5_decode;

var ParticipantsConnectionFragment_membershipStatusV5_fromString = ConversationParticipantsDisplay_participantsConnection_graphql.Utils.membershipStatusV5_fromString;

var ParticipantsConnectionFragment = {
  membershipStatusV5_decode: ParticipantsConnectionFragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: ParticipantsConnectionFragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationParticipantsDisplay(props) {
  var participantsConnection = use(props.participantsConnection);
  var agent = UserSession.useAgentInfo();
  var participants = Core__Array.keepSome(Core__Option.getOr(Core__Option.map(participantsConnection, (function (p) {
                        return p.edges;
                      })), [])).map(function (v) {
            return v.node;
          }).filter(function (v) {
          switch (v.__typename) {
            case "Agent" :
                return agent.id !== v.id;
            case "AnonymousConversationParticipant" :
            case "__unselected" :
                return true;
            
          }
        }).map(function (v) {
        switch (v.__typename) {
          case "Agent" :
              var match = v.membershipStatus;
              var id = v.id;
              var displayName = v.displayName;
              if (match !== undefined && (match === "ACTIVE" || match === "TERMINATED") && match !== "ACTIVE") {
                return {
                        TAG: "AgentTerminated",
                        displayName: displayName,
                        id: id
                      };
              }
              return {
                      TAG: "Agent",
                      id: id,
                      fragmentRefs: v.fragmentRefs,
                      displayName: displayName
                    };
          case "AnonymousConversationParticipant" :
          case "__unselected" :
              return "AnonymousConversationParticipant";
          
        }
      });
  return JsxRuntime.jsx(ConversationParticipantsDisplay$ByParticipants, {
              participants: participants,
              showNames: props.showNames
            });
}

var make = ConversationParticipantsDisplay;

exports.avatarStyles = avatarStyles;
exports.avatarClasses = avatarClasses;
exports.ByParticipants = ByParticipants;
exports.ParticipantsConnectionFragment = ParticipantsConnectionFragment;
exports.make = make;
/* Utils Not a pure module */
